document.addEventListener("DOMContentLoaded", function () {
    const searchButton = document.querySelector(".header-mobile__item.header-mobile__item--search");
    const searchCloseButton = document.querySelector(".halo-sidebar_search .halo-sidebar-close");

    const menuButton = document.querySelector(".header-mobile__item.header-mobile__item--menu");
    const menuCloseButton = document.querySelector(".site-nav-mobile .halo-sidebar-close");

    if (searchButton) {
        searchButton.addEventListener("click", function () {
            document.body.classList.add("open_search_mobile");
        });
    }

    if (searchCloseButton) {
        searchCloseButton.addEventListener("click", function () {
            document.body.classList.remove("open_search_mobile");
        });
    }

    if (menuButton) {
        menuButton.addEventListener("click", function () {
          document.body.classList.add("menu_open");
          function simulateTouch(element, eventType = "touchstart") {
            if (!element) return;
        
            const touchObj = new Touch({
                identifier: Date.now(),
                target: element,
                clientX: element.getBoundingClientRect().left + 5,
                clientY: element.getBoundingClientRect().top + 5,
                radiusX: 2.5,
                radiusY: 2.5,
                rotationAngle: 0,
                force: 1,
            });
        
            const touchEvent = new TouchEvent(eventType, {
                cancelable: true,
                bubbles: true,
                composed: true,
                touches: [touchObj],
                targetTouches: [touchObj],
                changedTouches: [touchObj]
            });
        
            element.dispatchEvent(touchEvent);
        }
        
        // Select Elements
        const menuToggle = document.querySelector(".mobileMenu-toggle");
        const sidebarWrapper = document.querySelector(".halo-sidebar-wrapper.custom-scrollbar");
        
        // Simulate touch events
        simulateTouch(menuToggle, "touchstart");
        simulateTouch(menuToggle, "touchend");
        
        simulateTouch(sidebarWrapper, "touchstart");
        simulateTouch(sidebarWrapper, "touchend");

            // document.querySelector('.mobileMenu-toggle').click();
            // document.querySelector('.halo-sidebar-wrapper.custom-scrollbar').click();
        });
    }

    if (menuCloseButton) {
        menuCloseButton.addEventListener("click", function () {
            document.body.classList.remove("menu_open");
        });
    }
});
